'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

var _request = require('../../common/request');

var _request2 = _interopRequireDefault(_request);

var _config = require('../../common/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResultMain = /** @class */function () {
    function SearchResultMain() {
        this.pageIndex = 1;
        this.searchBoxDom = document.getElementById('search');
        this.resultDom = document.getElementById('result');
        this.searchURL = '';
        this.searchURLObj = {};
        this.wmRequest = new _request2.default();
        this.init();
    }
    SearchResultMain.prototype.init = function () {
        this.initPageIndex();
        this.handleSearch();
        this.toggleTab();
    };
    SearchResultMain.prototype.initPageIndex = function () {
        var searchVal = decodeURIComponent(window.location.search);
        this.searchURL = searchVal.substring(1, searchVal.length);
        var searchURLArr = this.searchURL.split('&');
        for (var _i = 0, searchURLArr_1 = searchURLArr; _i < searchURLArr_1.length; _i++) {
            var item = searchURLArr_1[_i];
            var index = item.indexOf('=');
            var key = item.substring(0, index);
            var val = item.substring(index + 1, item.length);
            this.searchURLObj[key] = val;
        }
        this.pageIndex = Number(this.searchURLObj.page);
    };
    SearchResultMain.prototype.handleSearch = function () {
        var that = this;
        var inputBox = _tool2.default.$_select(this.searchBoxDom, '.help-input-box');
        var inputImgBox = _tool2.default.$_select(this.searchBoxDom, '.input-img-box');
        var inputDom = _tool2.default.$_select(this.searchBoxDom, '.search-input');
        var inputIcon = _tool2.default.$_select(this.searchBoxDom, '.input-icon');
        var searchBtn = _tool2.default.$_select(this.searchBoxDom, '.search-btn');
        var cloneInputValueDom = _tool2.default.$_select(this.searchBoxDom, '.clone-input-value');
        var isSelectText = false;
        var timer;
        clearTimeout(timer);
        timer = setTimeout(function () {
            var inputVal = inputDom.value.trim();
            if (inputVal != '') {
                cloneInputValueDom.innerText = inputVal;
            } else {
                cloneInputValueDom.innerText = '请输入关键词查找';
            }
        }, 50);
        inputBox.addEventListener('click', function (e) {
            inputDom.focus();
            inputIcon.classList.add('hide');
            searchBtn.classList.add('show');
            inputDom.classList.add('add-width');
            inputImgBox.classList.add('add-width');
            cloneInputValueDom.classList.add('hide');
            var inputVal = inputDom.value.trim();
            if (inputVal == '') {
                cloneInputValueDom.innerText = '';
            }
            var target = e.target;
            if (inputVal != '') {
                searchBtn.classList.add('active');
            } else {
                searchBtn.classList.remove('active');
            }
            if (searchBtn.contains(target)) {
                if (inputVal != '') {
                    that.pageIndex = 1;
                    window.location.href = "/searchResult?keywords=".concat(inputVal, "&tab=").concat(that.searchURLObj.tab, "&page=").concat(that.pageIndex);
                } else {
                    alert('关键词不能为空！');
                }
            }
            e.stopPropagation();
        });
        inputDom.addEventListener('keyup', function (event) {
            var e = event || window.event;
            var inputVal = inputDom.value.trim();
            if (inputVal != '') {
                searchBtn.classList.add('active');
                if (e.keyCode === 13) {
                    that.pageIndex = 1;
                    window.location.href = "/searchResult?keywords=".concat(inputVal, "&tab=").concat(that.searchURLObj.tab, "&page=").concat(that.pageIndex);
                }
            } else {
                searchBtn.classList.remove('active');
                if (e.keyCode === 13) {
                    alert('关键词不能为空！');
                }
            }
        });
        inputDom.addEventListener('select', function () {
            isSelectText = true;
        });
        document.addEventListener('click', function () {
            var timer;
            clearTimeout(timer);
            timer = setTimeout(function () {
                if (!isSelectText) {
                    inputIcon.classList.remove('hide');
                    searchBtn.classList.remove('show');
                    inputDom.classList.remove('add-width');
                    inputImgBox.classList.remove('add-width');
                    cloneInputValueDom.classList.remove('hide');
                    var inputVal = inputDom.value.trim();
                    if (inputVal != '') {
                        cloneInputValueDom.innerText = inputVal;
                    } else {
                        cloneInputValueDom.innerText = '请输入关键词查找';
                    }
                }
                isSelectText = false; // 回到初始状态
            }, 50);
        });
    };
    SearchResultMain.prototype.toggleTab = function () {
        var _this = this;
        var that = this;
        // 保存当前tab
        localStorage.setItem('current-tab', this.searchURLObj.tab);
        // 点击tab
        var tabItems = _tool2.default.$_selectAll(this.resultDom, '.tabs-box .tab-item');
        tabItems.forEach(function (item) {
            item.addEventListener('click', function () {
                // 修改地址栏
                var newTab = item.getAttribute('data-tab');
                var currentTab = localStorage.getItem('current-tab');
                if (currentTab != newTab) {
                    that.pageIndex = 1;
                }
                var currentUrl = "/searchResult?keywords=".concat(that.searchURLObj.keywords, "&tab=").concat(newTab, "&page=").concat(that.pageIndex);
                history.pushState(null, '', currentUrl);
                // 更新searchURLObj数据
                that.initPageIndex();
                // tab活跃状态
                tabItems.forEach(function (tItem) {
                    return tItem.classList.remove('active');
                });
                item.classList.add('active');
                // 渲染内容
                _this.getData(newTab);
            });
        });
        // 未点击tab
        var initSelectTab = _tool2.default.$_select(this.resultDom, ".tabs-box .tab-item.".concat(this.searchURLObj.tab));
        initSelectTab.click();
    };
    SearchResultMain.prototype.getData = function (tabType) {
        var _this = this;
        var that = this;
        // 清空
        var wrapper = _tool2.default.$_select(this.resultDom, '.result-wrapper');
        wrapper.innerHTML = '';
        // loading显示
        var loadingIcon = _tool2.default.$_select(this.resultDom, '.loading-box');
        loadingIcon.classList.add('active');
        // 请求数据
        this.wmRequest.ajax({
            url: _config2.default.WM_GETSEARCHRESULT,
            type: 'POST',
            data: {
                keywords: this.searchURLObj.keywords,
                tab: tabType,
                page: this.pageIndex
            }
        }).then(function (res) {
            loadingIcon.classList.remove('active');
            if (res.code == 200) {
                var data = res.data.data;
                var empty = _tool2.default.$_select(that.resultDom, '.empty-box');
                if (data.length == 0) {
                    // 缺省显隐
                    empty.classList.add('show');
                } else {
                    empty.classList.remove('show');
                    // 插入数据
                    that.handleAppend({
                        tabType: tabType,
                        data: data,
                        wrapper: wrapper
                    });
                    // 初始化分页器
                    var baseData = res.data;
                    _this.pageIndex = baseData.current_page;
                    var initData = {
                        pageIndex: baseData.current_page,
                        pageSize: baseData.per_page,
                        total: baseData.total
                    };
                    _this.initPagination(initData);
                }
            } else {
                console.log('error');
            }
        }).catch(function (err) {
            console.log(err);
        });
    };
    SearchResultMain.prototype.initPagination = function (initData) {
        var that = this;
        var pageIndex = initData.pageIndex,
            pageSize = initData.pageSize,
            total = initData.total;
        new Pagination({
            element: '#pagination',
            type: 2,
            layout: 'prev, pager, next, jumper',
            pageIndex: pageIndex,
            pageSize: pageSize,
            pageCount: 7,
            total: total,
            singlePageHide: true,
            ellipsis: true,
            disabled: true,
            currentChange: function currentChange(index) {
                window.scrollTo(0, 0);
                that.pageIndex = index;
                var currentUrl = "/searchResult?keywords=".concat(that.searchURLObj.keywords, "&tab=").concat(that.searchURLObj.tab, "&page=").concat(that.pageIndex);
                history.pushState(null, '', currentUrl);
                that.getData(that.searchURLObj.tab);
            }
        });
    };
    // 插入数据
    SearchResultMain.prototype.handleAppend = function (obj) {
        var wrapper = obj.wrapper,
            tabType = obj.tabType;
        var unitDom = this.handleUnit(obj);
        wrapper.insertAdjacentHTML('beforeend', unitDom);
        // 插入数据后，给软件应用绑定事件
        if (tabType == 'software') {
            this.jump();
            this.handleDownload();
            this.createAppQrcode();
        }
        if (tabType = 'operate') {
            this.createAppQrcode();
        }
    };
    // 组装dom单元
    SearchResultMain.prototype.handleUnit = function (obj) {
        var tabType = obj.tabType,
            data = obj.data;
        var appendStr = '';
        // 搜索词高亮
        var keywords = this.searchURLObj.keywords;
        var reg = new RegExp(keywords, 'g');
        var highlight = "<span>".concat(keywords, "</span>");
        switch (tabType) {
            case 'operate':
                for (var i = 0; i < data.length; i++) {
                    var title = data[i].title.replace(reg, highlight);
                    var details = data[i].details.replace(reg, highlight);
                    var winUrl = '';
                    var macUrl = '';
                    var androidUrl = '';
                    var iosUrl = '';
                    // 有且仅有任意一个Win下载地址时显示
                    if (data[i].win32_url == '' && data[i].win64_url != '') {
                        winUrl = "\n            <a href=\"".concat(data[i].win64_url, "\">\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_win.png\" alt=\"\">\n            <span class=\"win-span\">windows</span>\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_dl_blue.png\" alt=\"\">\n          </a>\n            ");
                    }
                    if (data[i].win64_url == '' && data[i].win32_url != '') {
                        winUrl = "\n            <a href=\"".concat(data[i].win32_url, "\">\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_win.png\" alt=\"\">\n            <span class=\"win-span\">windows</span>\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_dl_blue.png\" alt=\"\">\n          </a>\n            ");
                    }
                    // 两个Win下载地址都有
                    if (data[i].win32_url != '' && data[i].win64_url != '') {
                        winUrl = "\n            <div class=\"win-even\">\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_win.png\" alt=\"\">\n            <span class=\"win-span\">windows</span>\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_dl_blue.png\" alt=\"\">  \n            <div class=\"chlid-win\">\n              <a href=\"".concat(data[i].win32_url, '">\n                <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download1.svg" alt="">\n                <span>32\u4F4D\u4E0B\u8F7D</span>\n              </a>\n               <a href="').concat(data[i].win64_url, '">\n                <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download1.svg" alt="">\n                <span>64\u4F4D\u4E0B\u8F7D</span>\n              </a>\n            </div>\n          </div>\n            ');
                    }
                    // 有且仅有任意一个Mac下载地址时显示
                    if (data[i].macIntel_url == '' && data[i].macM1_url != '') {
                        macUrl = "\n            <a href=\"".concat(data[i].macM1_url, "\">\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_finder.svg\" alt=\"\">\n            <span class=\"win-span\">macOS</span>\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_dl_blue.png\" alt=\"\">\n          </a>\n            ");
                    }
                    if (data[i].macM1_url == '' && data[i].macIntel_url != '') {
                        macUrl = "\n            <a href=\"".concat(data[i].macIntel_url, "\">\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_finder.svg\" alt=\"\">\n            <span class=\"win-span\">macOS</span>\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_dl_blue.png\" alt=\"\">\n          </a>\n            ");
                    }
                    // 两个Mac下载地址都有
                    if (data[i].macIntel_url != '' && data[i].macM1_url != '') {
                        macUrl = "\n            <div class=\"win-even\">\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_finder.svg\" alt=\"\">\n            <span class=\"win-span\">macOS</span>\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_dl_blue.png\" alt=\"\">  \n            <div class=\"chlid-win\">\n              <a href=\"".concat(data[i].macIntel_url, '">\n                <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/ic_apple.svg" alt="">\n                <span>Intel\u82AF\u7247</span>\n              </a>\n               <a href="').concat(data[i].macM1_url, '">\n                <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/ic_apple.svg" alt="">\n                <span>Apple\u82AF\u7247</span>\n              </a>\n            </div>\n          </div>\n            ');
                    }
                    // Android下载
                    if (data[i].android_url != '') {
                        androidUrl = "               \n           <div class=\"down-qr down-qr-div\">\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_android.png\" alt=\"\">\n            <span>Android</span>\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_dl_blue.png\" alt=\"\">\n            <div class=\"download-qrcode\">\n              <div class=\"qr-code-img\" data-url=\"".concat(data[i].android_url, '"></div>\n              <p class="qr-p">\u626B\u7801\u4E0B\u8F7D APP</p>\n            </div>\n          </div>');
                    }
                    // ios下载
                    if (data[i].ios_url != '') {
                        iosUrl = " \n            <div class=\"down-qr down-qr-div\">\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_apple.png\" alt=\"\">\n            <span>iOS</span>\n            <img src=\"https://res.callmysoft.com/wm-static-resource/web/images/common/ic_dl_blue.png\" alt=\"\">\n            <div class=\"download-qrcode\">\n              <div class=\"qr-code-img\" data-url=\"".concat(data[i].ios_url, '"></div>\n              <p class="qr-p">\u626B\u7801\u4E0B\u8F7D APP</p>\n            </div>\n          </div>');
                    }
                    appendStr += "\n          <div class=\"result-item operate-style\">\n          <a href=\"".concat(data[i].details_url, "/help.html\" target=\"_blank\"><img\n              src=\"https://res.callmysoft.com/wm-static-resource/web/images/help/article-info-img2.png\" alt=\"\"></a>\n          <div class=\"operate-text\">\n            <h1><a href=\"").concat(data[i].details_url, "/help.html\" target=\"_blank\">").concat(title, "</a></h1>\n            <p>").concat(details, "</p>\n            <div class=\"item-bottom\">\n              <h2><img src=\"").concat(data[i].i_url, "\" alt=\"\">").concat(data[i].g_name, "</h2>\n              <span>").concat(data[i].create_time, '</span>\n              <div class="load-ico">\n              <!--\u6709\u4E14\u4EC5\u6709\u4EFB\u610F\u4E00\u4E2Awin\u4E0B\u8F7D\u65F6 && \u4E24\u4E2A\u4EE5\u4E0A\u65F6-->\n              ').concat(winUrl, '\n              <!--\u6709\u4E14\u4EC5\u6709\u4EFB\u610F\u4E00\u4E2Amac\u4E0B\u8F7D\u65F6 && \u4E24\u4E2A\u4EE5\u4E0A\u65F6-->\n              ').concat(macUrl, '\n              <!--android&&ios\u626B\u7801\u4E0B\u8F7D-->\n              ').concat(androidUrl, "\n              ").concat(iosUrl, "\n              </div>\n            </div>\n          </div>\n        </div>\n                ");
                }
                break;
            case 'course':
            case 'faq':
            case 'information':
                var _loop_1 = function _loop_1(i) {
                    var title = data[i].title.replace(reg, highlight);
                    var details = data[i].details.replace(reg, highlight);
                    appendStr += "<div class=\"result-item topic-style\">\n                      <a href=\"/support/".concat(data[i].article_id, ".html\" target=\"_blank\"><img class=\"info-img\" src=\"").concat(data[i].page_img, "\" onerror=\"this.src='https://res.callmysoft.com/wm-static-resource/web/images/help/article-info-img2.png'\" alt=\"\"></a>\n                      <div class=\"article-info-text\">\n                        <h1><a href=\"/support/").concat(data[i].article_id, ".html\" target=\"_blank\">").concat(title, "</a></h1>\n                        <p>").concat(details, "</p>\n                        <div class=\"article-tag\">\n                          <div class=\"tag-item\">\n                          ").concat(function () {
                        var _str = '';
                        for (var z = 0; z < data[i].key_word.length; z++) {
                            _str += "<a href=\"/tags/".concat(data[i].key_word[z], "\" target=\"_blank\">").concat(data[i].key_word[z], "</a>");
                        }
                        return _str;
                    }(), "\n                          </div>\n                          <span>").concat(data[i].create_time, "</span>\n                        </div>\n                      </div>\n                    </div>");
                };
                for (var i = 0; i < data.length; i++) {
                    _loop_1(i);
                }
                break;
            case 'software':
                var itemStr = '';
                for (var i = 0; i < data.length; i++) {
                    var title = data[i].g_name.replace(reg, highlight);
                    var details = data[i].g_website.replace(reg, highlight);
                    var winUrl = '';
                    var macUrl = '';
                    var androidUrl = '';
                    var iosUrl = '';
                    // 有且仅有任意一个Win下载地址时显示
                    if (data[i].win32_url == '' && data[i].win64_url != '') {
                        winUrl = "<li>\n                        <a href=\"".concat(data[i].win64_url, '">\n                          <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download1.svg" alt="">\n                          <span>Windows\u4E0B\u8F7D</span>\n                        </a>\n                      </li>');
                    }
                    if (data[i].win64_url == '' && data[i].win32_url != '') {
                        winUrl = "<li>\n                        <a href=\"".concat(data[i].win32_url, '">\n                          <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download1.svg" alt="">\n                          <span>Windows\u4E0B\u8F7D</span>\n                        </a>\n                      </li>');
                    }
                    // 两个Win下载地址都有
                    if (data[i].win32_url != '' && data[i].win64_url != '') {
                        winUrl = "<li>\n                        <a href=\"".concat(data[i].win32_url, '">\n                          <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download1.svg" alt="">\n                          <span>Win32\u4F4D\u4E0B\u8F7D</span>\n                        </a>\n                      </li>\n                      <li>\n                        <a href="').concat(data[i].win64_url, '">\n                          <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download1.svg" alt="">\n                          <span>Win64\u4F4D\u4E0B\u8F7D</span>\n                        </a>\n                      </li>');
                    }
                    // 有且仅有任意一个Mac下载地址时显示
                    if (data[i].macIntel_url == '' && data[i].macM1_url != '') {
                        macUrl = "<li>\n                        <a href=\"".concat(data[i].macM1_url, '">\n                          <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download2.svg" alt="">\n                          <span>MAC\u4E0B\u8F7D</span>\n                        </a>\n                      </li>');
                    }
                    if (data[i].macM1_url == '' && data[i].macIntel_url != '') {
                        macUrl = "<li>\n                        <a href=\"".concat(data[i].macIntel_url, '">\n                          <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download2.svg" alt="">\n                          <span>MAC\u4E0B\u8F7D</span>\n                        </a>\n                      </li>');
                    }
                    // 两个Mac下载地址都有
                    if (data[i].macIntel_url != '' && data[i].macM1_url != '') {
                        macUrl = "<li>\n                        <a href=\"".concat(data[i].macIntel_url, '">\n                          <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download2.svg" alt="">\n                          <span>Intel\u82AF\u7247\u4E0B\u8F7D</span>\n                        </a>\n                      </li>\n                      <li>\n                        <a href="').concat(data[i].macM1_url, '">\n                          <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download2.svg" alt="">\n                          <span>Apple\u82AF\u7247\u4E0B\u8F7D</span>\n                        </a>\n                      </li>');
                    }
                    // Android下载
                    if (data[i].android_url != '') {
                        androidUrl = '<li>\n                            <a>\n                              <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download3.svg" alt="">\n                              <span>Android\u4E0B\u8F7D</span>\n                              <div class="download-qrcode">\n                                <div class="qr-code-img" data-url="'.concat(data[i].android_url, '"></div>\n                                <p>\u626B\u7801\u4E0B\u8F7D APP</p>\n                              </div>\n                            </a>\n                          </li>');
                    }
                    // ios下载
                    if (data[i].ios_url != '') {
                        iosUrl = '<li>\n                        <a>\n                          <img src="https://res.callmysoft.com/wm-static-resource/web/images/common/inner-download4.svg" alt="">\n                          <span>iOS\u4E0B\u8F7D</span>\n                          <div class="download-qrcode">\n                            <div class="qr-code-img" data-url="'.concat(data[i].ios_url, '"></div>\n                            <p>\u626B\u7801\u4E0B\u8F7D APP</p>\n                          </div>\n                        </a>\n                      </li>');
                    }
                    var downloadBtnStr = '';
                    if (winUrl != '' || macUrl != '' || androidUrl != '' || iosUrl != '') {
                        downloadBtnStr = '<div class="kingshiper-procenter-container-list-down">\n                                <img src="https://res.callmysoft.com/wm-static-resource/web/images/help/ic_download.svg" alt="">\n                                <span>\u514D\u8D39\u4E0B\u8F7D</span>\n                                <i>\n                                  <img src="https://res.callmysoft.com/wm-static-resource/web/images/help/download-arrow-down.svg" alt="">\n                                  <img src="https://res.callmysoft.com/wm-static-resource/web/images/help/download-arrow-up.svg" alt="">\n                                </i>\n                                <ul>\n                                  '.concat(winUrl, "\n                                  ").concat(macUrl, "\n                                  ").concat(androidUrl, "\n                                  ").concat(iosUrl, "\n                                </ul>\n                              </div>");
                    }
                    itemStr += "<div class=\"result-item software-style\" data-learnmore=\"".concat(data[i].details_url, "\">\n                      <img class=\"kingshiper-procenter-container-list-logo\" src=\"").concat(data[i].i_url, "\" alt=\"\">\n                      <h6>").concat(title, "</h6>\n                      <p>").concat(details, '</p>\n                      <a class="kingshiper-procenter-container-list-learnmore">\u4E86\u89E3\u66F4\u591A\u76F8\u5173\u5185\u5BB9 <img\n                          src="https://res.callmysoft.com/wm-static-resource/web/images/procenter/procenter-learnmore.svg" alt=""></a>\n                      ').concat(downloadBtnStr, "\n                    </div>");
                }
                appendStr = "<div class=\"software-wrapper\">\n                      ".concat(itemStr, "\n                    </div>");
                break;
        }
        return appendStr;
    };
    SearchResultMain.prototype.jump = function () {
        var softwareItem = _tool2.default.$_selectAll(this.resultDom, '.software-style');
        softwareItem.forEach(function (item) {
            item.addEventListener('click', function () {
                var learnMoreUrl = item.getAttribute('data-learnmore');
                window.open(learnMoreUrl);
            });
        });
    };
    SearchResultMain.prototype.handleDownload = function () {
        var downloadBtn = _tool2.default.$_selectAll(this.resultDom, '.kingshiper-procenter-container-list-down');
        downloadBtn.forEach(function (item) {
            item.addEventListener('click', function (e) {
                if (!item.classList.contains('active')) {
                    downloadBtn.forEach(function (dItem) {
                        return dItem.classList.remove('active');
                    });
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
                e.stopPropagation();
            });
        });
        document.addEventListener('click', function () {
            downloadBtn.forEach(function (dItem) {
                return dItem.classList.remove('active');
            });
        });
    };
    // 循环生成app下载二维码
    SearchResultMain.prototype.createAppQrcode = function () {
        var appCodeListDom = _tool2.default.$_selectAll(this.resultDom, '.qr-code-img');
        appCodeListDom.forEach(function (item) {
            var downloadUrl = item.getAttribute('data-url');
            createQrcode(item, downloadUrl);
        });
    };
    return SearchResultMain;
}();
exports.default = SearchResultMain;